import { BBox } from "geojson";

import { MAP_MARGIN, MAP_PADDING_PANEL_HORIZONTAL, NETHERLANDS_BBOX } from "~/modules/map/mapConstants";

export const PLANNER_MAP_PADDING = {
    left: MAP_MARGIN,
    right: MAP_PADDING_PANEL_HORIZONTAL,
};

export const PLANNER_MAP_POINT_RADIUS_MARGIN_KM = 5;
export const PLANNER_MAP_VISIT_FIELDWORKER_RADIUS_KM = 100;

// may be replaced with regions later
export const PLANNERV2_DEFAULT_BOUNDS: BBox = NETHERLANDS_BBOX;
